import { useState } from "react";
import careers from "@config/careers.json";
import LeadForm from "../components/LeadForm.jsx";
import SectionTitle from "../components/SectionTitle.jsx";

export default function Careers({ t }) {
  const [job, setJob] = useState(careers[0]);

  return (
    <section className="section-shell py-14">
      <SectionTitle title="Careers" text="Open roles load from the careers configuration file and can be updated without component changes." />
      <div className="grid gap-6 lg:grid-cols-[1.2fr_0.8fr]">
        <div className="grid gap-5 md:grid-cols-2">
          {careers.map((item) => (
            <article key={item.id} className="premium-card p-6">
              <span className="rounded-full bg-ivory px-3 py-1 text-xs font-black text-maroon">{item.status}</span>
              <h2 className="mt-4 text-xl font-black text-royal">{item.title}</h2>
              <p className="mt-2 text-sm font-bold text-muted">{item.location} • {item.type}</p>
              <p className="mt-3 leading-7 text-muted">{item.summary}</p>
              <button className="focus-ring mt-5 rounded-sur bg-royal px-4 py-3 font-black text-white" onClick={() => setJob(item)}>{t.actions.apply}</button>
            </article>
          ))}
        </div>
        <LeadForm t={t} type="career" product={job?.title || ""} title="Apply Form" />
      </div>
    </section>
  );
}
